import { useRef } from "react";
import { Link } from "react-router-dom";
import { allFeatures, getWorkById } from "@/lib/content";

export default function FeatureSection() {
  const scroller = useRef<HTMLDivElement>(null);

  const scrollBy = (dir: number) => {
    if (!scroller.current) return;
    scroller.current.scrollBy({ left: dir * 340, behavior: "smooth" });
  };

  return (
    <section id="features" className="mx-auto w-full max-w-6xl scroll-mt-20 px-4 py-12 md:px-6 md:py-16 lg:px-8">
      <div className="flex items-end justify-between gap-4">
        <div>
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1.5 text-xs font-medium text-accent-800">
            <i className="ri-lightbulb-flash-line"></i>
            剧情解析精选专题
          </span>
          <h2 className="mt-3 font-heading text-2xl font-extrabold text-foreground-950 md:text-3xl">
            把剧情拆开看，才看得见用心
          </h2>
          <p className="mt-2 text-sm text-foreground-600">精挑细选的剧情解读与角色分析合集，横向滑动查看更多。</p>
        </div>
        <div className="hidden shrink-0 gap-2 md:flex">
          <button
            type="button"
            onClick={() => scrollBy(-1)}
            aria-label="向左滚动"
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-full border border-background-300 text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-700"
          >
            <i className="ri-arrow-left-s-line text-xl"></i>
          </button>
          <button
            type="button"
            onClick={() => scrollBy(1)}
            aria-label="向右滚动"
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-full border border-background-300 text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-700"
          >
            <i className="ri-arrow-right-s-line text-xl"></i>
          </button>
        </div>
      </div>

      <div ref={scroller} className="no-scrollbar mt-7 flex gap-5 overflow-x-auto pb-2">
        {allFeatures.map((item) => {
          const work = getWorkById(item.workId);
          return (
            <Link
              key={item.id}
              to={work ? `/detail/${work.id}` : "/category"}
              className="group flex w-[290px] shrink-0 flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50 transition-colors hover:border-primary-300 md:w-[330px]"
            >
              <div className="relative h-44 w-full overflow-hidden bg-background-200">
                <img
                  src={item.cover}
                  alt={`${item.title} 专题配图`}
                  title={`${item.title} 剧情解析专题`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-md bg-background-950/70 px-2.5 py-1 text-xs font-medium text-secondary-300">
                  {item.category}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
                  {item.title}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
                <div className="mt-4 flex items-center gap-2 text-xs text-foreground-500">
                  <i className="ri-user-3-line"></i>
                  <span>分析师 {item.author}</span>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}